"use client";

import { LandingSinglePageContext } from "@/helpers/contexts/LandingSinglePageContext";

import { IndexEntityPageProps } from "@/helpers/api/helpers/indexEntity";

import { LandingSinglePageProps } from "@/types/strapi/landing";

import LandingPage from "@/components/pages/landing/LandingPage";

import AILandingPage from "@/components/pages/ai-landing/AILandingPage";
import { AILanding } from "@/types/strapi/ai-landing";

export const IndexEntityPage = ({ entity, data }: IndexEntityPageProps) => {
  switch (entity) {
    case "landing":
      return (
        <LandingSinglePageContext.Provider value={data as LandingSinglePageProps}>
          <LandingPage />
        </LandingSinglePageContext.Provider>
      );
    case "ai-landing":
      return <AILandingPage {...(data as AILanding)} />;
    default:
      return null;
  }
};
